import { TweenMax } from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';


var controller = new ScrollMagic.Controller();

if ($('.top-career-last').length) {

  var flag = true;
  var lastcount = 0;
  var scene_career_last = new ScrollMagic.Scene({
    triggerElement: ".top-career-last",
    triggerHook: 'onCenter',
    // duration: 800,
    offset: 0
  })
    // .addIndicators()
    .addTo(controller);

  scene_career_last.on('enter', () => {
    // $(".top-career-last").addClass("is-animated");
    if (flag) {
      $(".top-career-last").addClass("is-animated");
      flag = false;
    }

    $('.is-last').on('animationend', function () {
      // transition終了時の処理
      // alert('transitionend');
      lastcount++

      if(lastcount < 3) {
        setTimeout(function () {
          $(".top-career-last-image").addClass("is-fade");
          // console.log('1つ目のタイマー');
          
          setTimeout(function () {
            $(".top-career-last").removeClass("is-animated");
            setTimeout(function () {
              $(".top-career-last").addClass("is-animated");
              $(".top-career-last-image").removeClass("is-fade");
              // console.log('2つ目のタイマー');
            }, 300);
          }, 800);
  
        }, 3000);
      }

    });

    // function event() {

    //   $(".top-career-last").removeClass("is-animated");
    //   $(".top-career-last").addClass("is-animated");
    //   // setTimeout(function () {
    //   // }, 300);
    //   // $(".top-career-last").addClass("is-animated");
    // }

    // タイマー開始
    // setInterval(event, 8000);

    var tl = new TimelineMax();

    tl
      .to($('.top-career-last-header'), 1, { y: "0px", alpha: 1, ease: Sine.easeOut });

    //triggerElementを過ぎたとき
  });
}


if ($('.top-message').length) {

  var scene_message = new ScrollMagic.Scene({
    triggerElement: ".top-message",
    triggerHook: 'onEnter',
    // duration: 800,
    offset: 0
  })
    // .addIndicators()
    .addTo(controller);

  scene_message.on('enter', () => {
    $(".top-message").addClass("is-animated");
    // $(".top-message").addClass("is-animated");
    // TweenMax.to($(".top-message"), 1, { alpha: 1, ease: Sine.easeOut })
    //triggerElementを過ぎたとき
  });
}


let targets = document.querySelectorAll('.top-career-list-item')

for (let target of targets) {

  var scene_career_list = new ScrollMagic.Scene({
    triggerElement: target,
    triggerHook: 'onCenter',
    // duration: 800,
    offset: '-100px'
  })
    // .addIndicators()
    .addTo(controller);

  scene_career_list.on('enter', () => {
    var tl = new TimelineMax();

    tl
      .to(target, 1, { y: "0px", alpha: 1, ease: Sine.easeOut });

    // target.classList.add('is-animated');
  });

}

let targets_contribution = document.querySelectorAll('.top-contribution')

for (let target of targets_contribution) {

  var scene_career_list = new ScrollMagic.Scene({
    triggerElement: target,
    triggerHook: 'onCenter',
    // duration: 800,
    offset: '-100px'
  })
    // .addIndicators()
    .addTo(controller);

  scene_career_list.on('enter', () => {
    target.classList.add('is-animated');
  });

}


let targets_serialization = document.querySelectorAll('.top-serialization')

for (let target of targets_serialization) {

  var scene_career_list = new ScrollMagic.Scene({
    triggerElement: target,
    triggerHook: 'onCenter',
    // duration: 800,
    offset: '-100px'
  })
    // .addIndicators()
    .addTo(controller);

  scene_career_list.on('enter', () => {
    target.classList.add('is-animated');
  });

}